import { ref, toRef, watch } from 'vue'
import { useReviewSetSteps } from './useReviewSetSteps'
import { useReviewSetData } from './useReviewSetData'
import useCheckScreen from '@/composables/useCheckScreen.js'
import {
    editAndReviewSetModalStyles,
    mobileEditAndReviewStyles,
    tableteditAndReviewSetModalStyles
} from '@/components/booking-manager/booking-part/advanced-artist/edit-set/styles'

export const useReviewSet = (props, { emit }) => {
    const mode = toRef(props, 'mode')
    const set = toRef(props, 'set')
    const show = toRef(props, 'show')

    const eventId = ref(null)
    const venueId = ref(null)
    const artistId = ref(null)
    const openModal = ref(show.value)
    const { isMobile, isTablet } = useCheckScreen()
    const { currentStep, findStep, updateStep } = useReviewSetSteps(mode)
    const { acceptConfirmation, declineConfirmation, messageVenue } = useReviewSetData(
        mode,
        emit,
        openModal,
        updateStep,
        eventId,
        venueId,
        artistId
    )
    watch(
        () => set.value,
        (set) => {
            const firstStep = findStep('initial')

            firstStep.set = set
            eventId.value = set.eventId
            venueId.value = set.venueId
            artistId.value = set.artistId
        },
        { immediate: true }
    )

    watch(
        () => show.value,
        (show) => {
            openModal.value = show
        }
    )
    watch(
        () => openModal.value,
        (openModal) => {
            emit('update:show', openModal)
        }
    )

    const modalStyles = ref({ modalWrapper: null })
    watch(
        [() => isMobile.value, () => isTablet.value],
        ([isMobile, isTablet]) => {
            if (isMobile) {
                modalStyles.value = mobileEditAndReviewStyles
            } else if (isTablet) {
                modalStyles.value = tableteditAndReviewSetModalStyles
            } else {
                modalStyles.value = editAndReviewSetModalStyles
            }
        },
        { immediate: true }
    )
    const rejectConfirmation = () => {
        updateStep('reject')
    }

    return {
        modalStyles,
        openModal,
        currentStep,
        updateStep,
        acceptConfirmation,
        rejectConfirmation,
        declineConfirmation,
        messageVenue
    }
}
